// ts-check
/** @jsx jsx */
/** @jsxFrag React.Fragment */
import { Flex } from '@bottlebooks/gatsby-theme-base/src';
import { jsx } from 'theme-ui';
import ProductCardGoToProductAction from './ProductCardGoToProductAction';

export default function ProductCardActions({ product, ...rest }) {
  return (
    <Flex direction="column" gap={2.5} {...rest}>
      <ProductCardGoToProductAction product={product} />
    </Flex>
  );
}
